module.exports = __webpack_public_path__ + "static/media/american-express.00b51627.svg";